export const openedModalZindexList: Array<number> = [];
